import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';

import MainPagetitle from '../../layouts/MainPagetitle';
import CamperService from '../../api/services/CamperService';
import AdminDatesService from '../../api/services/AdminDatesService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Modal, Button } from 'react-bootstrap';
import Select from "react-select";
const EditMinimumRent = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [camper, setCamper] = useState([]);
    const [selectedCamperType, setSelectedCamperType] = useState(null);
    const [selectedCamperTypeId, setSelectedCamperTypeId] = useState('');
    const [RentData, setRentData] = useState([]);
    const [error, setError] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [RestrictedModal, setRestrictedModal] = useState(false);

    const getMinimumRentData = async () => {
        try {
            setisloading(true);
            let responsedata = await AdminDatesService.show(params.id).json();
            let camper = await CamperService.index().json();

            var camperdata = camper.data.filter(function (item) {
                return item.camper_type_id == 1 && item.status == 1
            });

            setCamper(camperdata);
            setRentData(responsedata.data)
 
            const getSelected = [].concat.apply([], responsedata.data.camper_ids.map((element) => {
                return camperdata.filter(c => c.id == element);
            }));
            if (responsedata.data.camper_ids.length === camperdata.length) {
                var selectedCamperType = camperdata.map(option => option.id);

                setSelectedCamperType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
                setSelectedCamperTypeId(selectedCamperType);
            }
            else {
                const selectedCamperTitles = getSelected.map(option => ({
                    value: option.id,
                    label: option.title,
                }));

                setSelectedCamperType(selectedCamperTitles);
                setSelectedCamperTypeId(getSelected.map(option => option.id));

            }

            setisloading(false);
        } catch (error) {
            console.log(error);
        } finally {
            setisloading(false);
        }
    };
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            // getCamper().then(() => {
            // Once camper data is fetched, fetch rent data
            getMinimumRentData();
            // });
        }
        else {
            navigate('/')
        }
    }, []);


    const onSubmitForm = async (event) => {
        event.preventDefault();
        setError("")
        try {
            var userData = {

                "start_date": event.target.start_date.value,
                "end_date": event.target.end_date.value,
                "camper_ids": selectedCamperTypeId ? selectedCamperTypeId : [],
                "minimum_rent_duration": event.target.minimum_rent_duration.value,
                "english_message": event.target.english_message.value,
                "german_message": event.target.german_message.value
            }
            var startDate = new Date(userData.start_date);
            var endDate = new Date(userData.end_date);
            if (startDate > endDate) {
                setError("The Start Date cannot be later than the End Date.");
                return; // Exit the function if the dates are not valid
            }
            else {
                let responseData = await AdminDatesService.update(params.id, userData).json()
                if (responseData.status === false) {
                    setError(responseData.message);
                    return; 
                  }
                if (responseData.status === true) {
                    setRestrictedModal(true)
                }
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    };

    const handleSelectCamperType = (selectedOption) => {
        var selectedCamperType;
        if (selectedOption.some(option => option.value === 'select-all-vehicles')) {
            selectedCamperType = camper.map(option => option.id);
            setSelectedCamperType([{ value: 'select-all-vehicles', label: 'Select All Vehicles' }]);
            setSelectedCamperTypeId(selectedCamperType);
        } else {

            selectedCamperType = selectedOption.map(option => option.value);
            setSelectedCamperType(selectedOption);
            setSelectedCamperTypeId(selectedCamperType);
        }
    }
    if (isLoading) {
        return <LogoAnimationLoader />;  // Placeholder or loading spinner
    }
    return (
        <>
            <MainPagetitle mainTitle="Edit Minimum Rent Duration" pageTitle={'Edit Minimum Rent Duration'} parentTitle={'Home'} />
            <div className="container-fluid">
                <form className="form-valide" onSubmit={onSubmitForm}>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Edit Minimum Rent Duration</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >StartDate<span className="text-danger">*</span></label>
                                            <input type="date" className="form-control" name='start_date'
                                                defaultValue={
                                                    RentData.start_date
                                                        ? RentData.start_date
                                                        : ''
                                                }
                                                id="val-username"
                                            />
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >EndDate<span className="text-danger">*</span></label>
                                            <input type="date" className="form-control" name='end_date'
                                                defaultValue={
                                                    RentData.end_date
                                                        ? RentData.end_date
                                                        : ''
                                                } id="val-username"
                                            />
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="exampleFormControlInput2" className="form-label"> Select Camper <span className="text-danger">*</span></label>

                                            <Select
                                                name="camper_ids"
                                                value={selectedCamperType}
                                                placeholder="Select Vehicles"
                                                options={[
                                                    { value: 'select-all-vehicles', label: 'Select All Vehicles' }, // Add 
                                                    ...(camper?.map(attr => ({
                                                        value: attr.id,
                                                        label: attr.title,
                                                    })) || []),
                                                ]}
                                                isMulti
                                                onChange={(selectedOption) => handleSelectCamperType(selectedOption)}
                                                className={`select2-selection`} />
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >Minimum Rent Duration<span className="text-danger">*</span></label>
                                            <input type="number" className="form-control" name='minimum_rent_duration'
                                                defaultValue={
                                                    RentData.minimum_rent_duration
                                                        ? RentData.minimum_rent_duration
                                                        : 2
                                                }
                                                min={2}
                                                id="val-minimum_rent_duration"
                                            />
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >English Message<span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name='english_message'
                                                defaultValue={
                                                    RentData.english_message
                                                        ? RentData.english_message
                                                        : ''
                                                }
                                                id="val-english_message"
                                            />
                                        </div>
                                        <div className="col-xl-12 mb-3">
                                            <label htmlFor="val-username" className="form-label" >German Message<span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" name='german_message'
                                                defaultValue={
                                                    RentData.german_message
                                                        ? RentData.german_message
                                                        : ''
                                                }
                                                id="val-german_message"
                                            />
                                        </div>
                                    </div>
                                    <h5 style={{ color: 'red' }}>{error}</h5>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            {isLoading && <LogoAnimationLoader />}
            <Modal centered className="mark-attendence" show={RestrictedModal}>
                <Modal.Header>
                    <Modal.Title>Update </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setRestrictedModal(false)}></Button>
                </Modal.Header>
                <Modal.Body>Update Minimum Rent Duration Successfully!!!.</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to={'/admin/minimumrentduration-list'} variant="danger light" onClick={() => setRestrictedModal(false)}>Close</Link>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default EditMinimumRent;